import Stepper from '@mui/material/Stepper';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';

const Connector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 9,
    left: 'calc(-50% + 10px)',
    right: 'calc(50% + 10px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--trashie-ui-lime)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--trashie-ui-lime)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: 'var(--trashie-ui-faded-black-30)',
    borderTopWidth: 2,
  },
}));

const StyledStepper = styled((props) => (
  <Stepper
    {...props}
    connector={<Connector />}
  />
))({
  flex: 1,
});

export default StyledStepper;
